import React from 'react';
import { Box, Chip, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Category } from '../types/forum.types';

interface CategoryFilterProps {
  categories: Category[];
  selectedCategory: number | null;
  onCategorySelect: (categoryId: number | null) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onCategorySelect
}) => {
  const theme = useTheme();
  const isDarkTheme = theme.name === 'dark';

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'medium', color: isDarkTheme ? alpha(theme.palette.text.primary, 0.7) : 'text.secondary' }}>
        Filter by category
      </Typography>
      
      <Box sx={{ 
        display: 'flex', 
        gap: 1, 
        flexWrap: 'wrap',
        transition: 'all 0.3s ease-in-out'
      }}>
        <Chip
          label="All"
          onClick={() => onCategorySelect(null)}
          variant={selectedCategory === null ? 'filled' : 'outlined'}
          sx={{ 
            bgcolor: selectedCategory === null 
              ? isDarkTheme ? '#64AFE3' : 'primary.main'
              : 'transparent',
            color: selectedCategory === null 
              ? isDarkTheme ? '#000000' : 'background.paper' 
              : isDarkTheme ? '#64AFE3' : 'primary.main',
            borderColor: isDarkTheme ? '#64AFE3' : 'primary.main',
            borderRadius: isDarkTheme ? '4px' : '0px',
            transition: 'all 0.2s ease-in-out',
            fontWeight: 'medium',
            boxShadow: selectedCategory === null && isDarkTheme ? '0 2px 4px rgba(0, 0, 0, 0.2)' : 'none',
            '&:hover': { 
              bgcolor: selectedCategory === null 
                ? isDarkTheme ? '#8ABFEB' : 'primary.dark'
                : isDarkTheme 
                  ? alpha('#64AFE3', 0.1)
                  : 'action.hover',
              transform: 'translateY(-2px)',
              boxShadow: isDarkTheme ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.1)'
            }
          }}
        />
        {categories.map(category => (
          <Chip
            key={category.id}
            label={category.name}
            onClick={() => onCategorySelect(category.id)}
            variant={selectedCategory === category.id ? 'filled' : 'outlined'}
            sx={{ 
              bgcolor: selectedCategory === category.id 
                ? isDarkTheme ? '#64AFE3' : 'primary.main'
                : 'transparent',
              color: selectedCategory === category.id 
                ? isDarkTheme ? '#000000' : 'background.paper' 
                : isDarkTheme ? '#64AFE3' : 'primary.main',
              borderColor: isDarkTheme ? '#64AFE3' : 'primary.main',
              borderRadius: isDarkTheme ? '4px' : '0px',
              transition: 'all 0.2s ease-in-out',
              fontWeight: 'medium',
              boxShadow: selectedCategory === category.id && isDarkTheme ? '0 2px 4px rgba(0, 0, 0, 0.2)' : 'none',
              '&:hover': { 
                bgcolor: selectedCategory === category.id 
                  ? isDarkTheme ? '#8ABFEB' : 'primary.dark'
                  : isDarkTheme 
                    ? alpha('#64AFE3', 0.1)
                    : 'action.hover',
                transform: 'translateY(-2px)',
                boxShadow: isDarkTheme ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.1)'
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
}; 